import React, { useState, useEffect } from 'react';
import { Table, Input, Button } from 'antd';
import { BreathAPIs } from '../../APIs/BreathAPIs';
import styles from './styles.module.css';
import { toast, ToastContainer } from 'react-toastify';
import { Container } from 'react-bootstrap';
import { IoMdCloseCircle } from 'react-icons/io';

const GuestUsers = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [guestUsers, setGuestUsers] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [pagination, setPagination] = useState({
        total: 0,
        current: 1,
        pageSize: 10,
        totalPages: 0
    });

    useEffect(() => {
        getGuestUsers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getGuestUsers = async (page = 1, pageSize = 10, withoutFilter = false) => {
        setIsLoading(true);
        try {
            const res = await BreathAPIs.getGuestUserList(withoutFilter ? { page: 1, limit: 10 } : { page, limit: pageSize, filterText: filterText ? filterText : '' });
            setGuestUsers(res.data.guestUsers);
            setPagination({
                total: res.data.pagination.total,
                current: res.data.pagination.current,
                pageSize: res.data.pagination.pageSize,
                totalPages: res.data.pagination.totalPages
            });
        } catch (error) {
            console.error(error);
            toast.error('Error fetching guest users.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleTableChange = (pagination) => {
        const { current, pageSize } = pagination;
        getGuestUsers(current, pageSize);
    };

    const handleClearFilter = () => {
        setFilterText('');
        getGuestUsers(1, 10, true);
    };

    const columns = [
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
            render: (text) => (<span>{text ? text : '-'}</span>),
        },
        {
            title: 'Guest ID',
            dataIndex: 'guestId',
            key: 'guestId',
        },
        {
            title: 'Joined',
            dataIndex: 'date',
            key: 'date',
            render: (text) => (<span>{text ? new Date(text).toLocaleString() : '-'}</span>),
        },
    ];

    return (
        <Container>
            <ToastContainer></ToastContainer>
            <div className={styles['filter']}>
                <div className={styles['filter-left']}>
                    <Input value={filterText} placeholder='Search: Email, Phone' onChange={(e) => setFilterText(e.target.value)} />
                </div>
                <div className={styles['filter-right']}>
                    <Button onClick={() => { getGuestUsers() }} type="primary">Filter</Button>
                    <Button onClick={handleClearFilter} className={styles['custom-btn']} type="primary" danger color='white' shape="circle" icon={<IoMdCloseCircle />} ></Button>
                </div>
            </div>

            <Table
                loading={isLoading}
                dataSource={guestUsers}
                columns={columns}
                rowKey="_id"
                pagination={pagination}
                onChange={handleTableChange}
                className={styles['data-list']}
                bordered
                size="middle"
                scroll={{ x: 'calc(600px + 50%)' }}
            />
        </Container>
    );
};

export default GuestUsers;
